
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/shop/[...slug]",
      function () {
        return require("private-next-pages/[lang]/shop/[...slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/shop/[...slug]"])
      });
    }
  